package org.ksdfv.thelema.kxjs.data

import org.khronos.webgl.Uint8Array
import org.ksdfv.thelema.data.IByteData
import org.ksdfv.thelema.data.IData

/** @author zeganstyl */
class JsData: IData {
    override val nullBuffer: IByteData = bytes(0)

    val jsDecodeURI = js("decodeURI")
    val jsEncodeURI = js("encodeURI")

    override fun bytes(capacity: Int): IByteData =
        JsUInt8Array(Uint8Array(capacity))

    // TODO https://github.com/beatgammit/base64-js

    override fun decodeBase64(text: String): ByteArray {
        TODO("Not yet implemented")
    }

    override fun decodeBase64(text: String, out: IByteData): IByteData {
        TODO("Not yet implemented")
    }

    override fun decodeURI(uri: String): String = jsDecodeURI(uri) as String

    override fun destroyBytes(data: IByteData) {}

    override fun encodeBase64(data: IByteData): String {
        TODO("Not yet implemented")
    }

    override fun encodeBase64(bytes: ByteArray): String {
        TODO("Not yet implemented")
    }

    override fun encodeURI(uri: String): String = jsEncodeURI(uri) as String
}